import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import 'lib-flexible/flexible';
// 进度条
import 'nprogress/nprogress.css';
import PAGE_API from '@/apis/pageApi';
import HTTP_API from '@/apis/httpApi';
import fn from '@/utils/fn.ts';
import axios, { Method, AxiosRequestConfig, AxiosResponse } from "axios";
Vue.prototype.$axios = axios;
import Component from 'vue-class-component';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
import {
    Button, Tabbar, TabbarItem, NavBar, SwipeCell, List, PullRefresh,
    CountDown, Form, Field, DropdownMenu, DropdownItem, Toast, Cell, Sticky, Popup, Dialog,
    Tab, Tabs, IndexBar, IndexAnchor,
} from 'vant';
import { Image as VanImage } from 'vant';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
Viewer.setDefaults({
    // 需要配置的属性
    // inline: true,
    // 右上角箭头
    button: false,
    // 缩略图
    navbar: false,
    // 图片详情
    title: false,
    // 控制按钮
    toolbar: false,
    // rotatable: false,
    fullscreen: true
    // zoomable: false
    // movable: false
    // tooltip: false
})
// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$PAGE_API = PAGE_API
Vue.prototype.$HTTP_API = HTTP_API

Vue.use(DropdownItem).use(Toast).use(Cell).use(Sticky)
    .use(Button).use(Tabbar).use(TabbarItem).use(NavBar).use(SwipeCell)
    .use(List).use(PullRefresh).use(VanImage).use(CountDown)
    .use(Form).use(Field).use(Popup).use(Dialog).use(DropdownMenu)
    .use(Tab).use(Tabs).use(IndexBar).use(IndexAnchor)
Vue.config.productionTip = false;
window.App = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
